import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { FaCheckCircle, FaExclamationCircle, FaSpinner } from "react-icons/fa";

const AUTHAPP_URL = process.env.REACT_APP_AUTH_SERVICE_URL || 'http://localhost:8081';

const VerifyEmailPage = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    
    const [status, setStatus] = useState("loading"); // loading, success, error
    const [message, setMessage] = useState("");
    const hasCalled = React.useRef(false);

    useEffect(() => {
        if (!token || hasCalled.current) {
            return;
        }
        hasCalled.current = true;

        const verify = async () => {
            try {
                const response = await axios.get(`${AUTHAPP_URL}/api/user/verify-email?token=${token}`);
                setStatus("success");
                setMessage(response.data.message || "Email verified successfully!");
            } catch (error) {
                setStatus("error");
                if (error.response?.data?.message) {
                    setMessage(error.response.data.message);
                } else {
                    setMessage("Verification failed. The link may have expired or is invalid.");
                }
            }
        };

        verify();
    }, [token]);

    return (
        <div style={{ 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center", 
            minHeight: "100vh", 
            background: "#f3f4f6" 
        }}>
            <div style={{
                background: "white",
                padding: "40px",
                borderRadius: "12px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                textAlign: "center",
                maxWidth: "450px",
                width: "100%"
            }}>
                {status === "loading" && (
                    <>
                        <FaSpinner className="fa-spin" style={{ fontSize: "50px", color: "#4f46e5", marginBottom: "20px" }} />
                        <h2 style={{ color: "#333", fontSize: "1.5rem" }}>Verifying your email...</h2>
                        <p style={{ color: "#666", marginTop: "10px" }}>Please wait while we validate your token.</p>
                    </>
                )}

                {status === "success" && (
                    <>
                        <FaCheckCircle style={{ fontSize: "60px", color: "#10b981", marginBottom: "20px" }} />
                        <h2 style={{ color: "#333", fontSize: "1.5rem" }}>Verified!</h2>
                        <p style={{ color: "#666", marginTop: "10px", marginBottom: "25px" }}>{message}</p>
                        <Link to="/" style={{ 
                            display: "inline-block", 
                            background: "#4f46e5", 
                            color: "white", 
                            padding: "12px 24px", 
                            borderRadius: "8px", 
                            textDecoration: "none",
                            fontWeight: "bold",
                            transition: "background 0.3s"
                        }}>
                            Go to Login
                        </Link>
                    </>
                )}

                {status === "error" && (
                    <>
                        <FaExclamationCircle style={{ fontSize: "60px", color: "#ef4444", marginBottom: "20px" }} />
                        <h2 style={{ color: "#333", fontSize: "1.5rem" }}>Verification Failed</h2>
                        <p style={{ color: "#666", marginTop: "10px", marginBottom: "25px" }}>{message}</p>
                        <Link to="/" style={{ 
                            display: "inline-block", 
                            background: "#e5e7eb", 
                            color: "#4b5563", 
                            padding: "12px 24px", 
                            borderRadius: "8px", 
                            textDecoration: "none",
                            fontWeight: "bold",
                            transition: "background 0.3s"
                        }}>
                            Return to Login
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};

export default VerifyEmailPage;
